import React, { useState } from 'react';
import './partner-styles.css';

const PartnerApplicationFilters = ({ onFilterChange, onDownloadCSV }) => {
    const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        status: '',
        mobile: ''
    });

    const handleInputChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleApplyFilters = () => {
        onFilterChange(filters);
    };

    const handleClearFilters = () => {
        const clearedFilters = {
            startDate: '',
            endDate: '',
            status: '',
            mobile: ''
        };
        setFilters(clearedFilters);
        onFilterChange(clearedFilters);
    };

    return (
        <div className="partner-filters">
            <div className="partner-filters-row">
                <div className="partner-filter-group">
                    <label className="partner-filter-label">Start Date</label>
                    <input
                        type="date"
                        className="partner-filter-input"
                        value={filters.startDate}
                        onChange={(e) => handleInputChange('startDate', e.target.value)}
                    />
                </div>

                <div className="partner-filter-group">
                    <label className="partner-filter-label">End Date</label>
                    <input
                        type="date"
                        className="partner-filter-input"
                        value={filters.endDate}
                        onChange={(e) => handleInputChange('endDate', e.target.value)}
                    />
                </div>

                <div className="partner-filter-group">
                    <label className="partner-filter-label">Status</label>
                    <select
                        className="partner-filter-select"
                        value={filters.status}
                        onChange={(e) => handleInputChange('status', e.target.value)}
                    >
                        <option value="">All Status</option>
                        <option value="New">New</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Pending">Pending</option>
                        <option value="Disbursed">Disbursed</option>
                    </select>
                </div>

                <div className="partner-filter-group">
                    <label className="partner-filter-label">Mobile Number</label>
                    <input
                        type="text"
                        className="partner-filter-input"
                        placeholder="Enter mobile number"
                        value={filters.mobile}
                        onChange={(e) => handleInputChange('mobile', e.target.value)}
                        maxLength={10}
                    />
                </div>
            </div>


            <div className="partner-filter-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px' }}>
                <button
                    className="btn btn-success"
                    onClick={onDownloadCSV}
                    style={{ padding: '8px 16px' }}
                >
                    <i className="fa fa-download"></i> Download CSV
                </button>
                <div>
                    <button
                        className="btn btn-primary"
                        onClick={handleApplyFilters}
                        style={{ marginRight: '10px', padding: '8px 16px' }}
                    >
                        <i className="fa fa-search"></i> Apply Filters
                    </button>
                    <button
                        className="btn btn-default"
                        onClick={handleClearFilters}
                        style={{ padding: '8px 16px' }}
                    >
                        <i className="fa fa-times"></i> Clear
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PartnerApplicationFilters;
